import Glide from '@glidejs/glide';

const homepageCarousel = () => {
  const carouselElem = document.getElementsByClassName(
    'homepage-carousel-card'
  );

  if (carouselElem.length === 0) {
    return false;
  }

  Array.from(carouselElem).forEach(item => {
    new Glide(item, {
      type: 'carousel',
      autoplay: 4000
    }).mount();
  });
};

export default homepageCarousel;
